import { LmgService } from "../resource";

const UserModule = {
  namespaced: true,
  state: {
    datas: [],
    data: {}
  },
  mutations: {
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_DATA(state, payload) {
      state.data = payload;
    }
  },
  actions: {
    createData({ commit, state }, payload) {
      return LmgService.UserCreate(payload);
    },
    changePassword({ commit, state }, payload) {
      return LmgService.UserChangePassword(payload);
    },
    changePasswordByAdmin({ commit, state }, payload) {
      return LmgService.UserChangePasswordByAdmin(payload.ID, payload);
    },
    setActive({ commit, state }, payload) {
      return LmgService.UserSetActive(payload.ID, payload);
    },
    apiVersion({ commit, state }, payload) {
      return LmgService.GetAPIVersion();
    },
    async listData({ commit, state }, payload) {
      try {
        const data = await LmgService.UserList(payload);
        if (data.data.Data == null) {
          commit("SET_DATAS", []);
        } else {
          commit("SET_DATAS", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS", []);
      }
    }
  },
  getters: {
    getData(state) {
      return state.datas;
    },
    
  }
};

export default UserModule;
